import moment from 'moment';

import Table, { TableCell, TableRow } from '~/components/Table';
import { flattenObjectForDisplay, formatColumnLabel } from '~/lib/helpers';

import styles from './EventsListItem.style';

class ListEventsItem extends React.Component {
  formatTimestamp = (time) => moment(time).format('MMM Do YYYY, h:mm:ss a');

  formatLabel = (key) =>
    key
      .split(':')
      .map((keyPart) => (
        <span key={keyPart}>{formatColumnLabel(keyPart)} </span>
      ));

  renderDetailTable = () => {
    const { event } = this.props;
    const flatEvent = flattenObjectForDisplay(event);
    const tableRows = Object.keys(flatEvent).map((key) => (
      <TableRow key={key}>
        <TableCell>{this.formatLabel(key)}</TableCell>
        <TableCell title={flatEvent[key].toString()} ellipsis>
          {flatEvent[key]}
        </TableCell>
      </TableRow>
    ));

    return <Table>{tableRows}</Table>;
  };

  render() {
    const { classes, event, expanded } = this.props;

    return (
      <div>
        <TableRow key={event.id} hover className={classes.tableRow}>
          <TableCell link ellipsis title={event.type.toString()}>
            {event.type}
          </TableCell>

          <TableCell ellipsis sub title={event.timestamp}>
            {this.formatTimestamp(event.timestamp)}
          </TableCell>
        </TableRow>

        {expanded && (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={
              expanded
                ? classes.detailContainerExpanded
                : classes.detailContainer
            }>
            {this.renderDetailTable()}
          </div>
        )}
      </div>
    );
  }
}

ListEventsItem.propTypes = {
  event: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListEventsItem);
